import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { resetStores } from '@state/signal-state.util';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { decrypt, encrypt } from '../utils/encryption.util';
import { UserType } from '@shared/enums/auth.enum';
interface LoginFormValue {
  email: string;
  password: string;
}

export interface CurrentUserMedia {
  avatar: string | null;
  logo: string | null;
}

export type CurrentUserMediaQuery = {
  organizationId?: string;
  organizationType?: UserType.Brand | UserType.Factory | UserType.Consultant;
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private _router = inject(Router);
  private readonly endPoint = environment.API_ENDPOINT + 'auth/';
  login(loginFormValue: LoginFormValue): Observable<any> {
    return this.http.post(this.endPoint + 'login', loginFormValue);
  }
  logout(): void {
    resetStores();
    localStorage.clear();
    window.location.href = `${environment.SUPPLIER_WEB_ENDPOINT}sign-in`;
  }
  register(payload: any): Observable<any> {
    return this.http.post(this.endPoint + 'register', payload);
  }
  forgotPassword(payload: { email: string; channel?: 'whatsapp' | 'email' }): Observable<any> {
    return this.http.post(this.endPoint + 'forgot-password', payload);
  }
  resetPassword(payload: any): Observable<any> {
    return this.http.post(this.endPoint + 'reset-password', payload);
  }
  changePassword(payload: any): Observable<any> {
    return this.http.post(this.endPoint + 'change-password', payload);
  }
  refreshToken(payload: any): Observable<any> {
    return this.http.post(`${this.endPoint}refresh-token`, payload).pipe(
      tap((res: any) => {
        localStorage.setItem('token', encrypt(res.data.token));
      })
    );
  }
  getAccessToken(): string | null {
    const token = localStorage.getItem('token');
    return token ? decrypt(token) : null;
  }
  generateQRCode(userID: string | number): Observable<any> {
    return this.http.get(`${this.endPoint}generate-qr/${userID}`);
  }
  verifyQr(userId: string, otp: string): Observable<any> {
    const body = { userId, otp };
    return this.http.post(`${this.endPoint}verify-qr`, body);
  }
  getCurrentUserMedia(query: CurrentUserMediaQuery): Observable<{ data: CurrentUserMedia }> {
    let params = new HttpParams();
    if (query.organizationId && query.organizationType) {
      params = params
        .set('organizationId', query.organizationId)
        .set('organizationType', query.organizationType);
    }

    return this.http.get<{ data: CurrentUserMedia }>(`${this.endPoint}media`, { params });
  }
}
